export default __webpack_public_path__ + "static/media/indexxai.09ca2fb5.png";